import Vue from 'vue';
import wysiwyg from 'vue-wysiwyg';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
import store from '../store';
import config from '../config';

Vue.use(wysiwyg, {
  hideModules: { table: true },
  image: {
    uploadURL: `${config.api.baseUrl}/api/notif/blogs/attachment`,
    dropzoneOptions: {
      headers: { Authorization: `bearer ${store.state.auth.token}` },
      acceptedFiles: 'image/*',
      maxFilesize: 2,
    },
  },
  maxHeight: '1000px',
});
